<!-- https://8es9hr.axshare.com/#g=1&p=%E7%8F%BE%E9%87%91%E6%94%B6%E6%AC%BE%E4%BD%9C%E6%A5%AD -->
<!-- 現金收款作業 -->
<template>
    <div class="row">
        <div class="col-12">
            <div class="col-block">
                <div class="block-content">
                    <div class="show-container">
                        <div class="show"></div>
                    </div>
                    <h3
                        v-if="iframeshow === true"
                        class="mb-2"
                    >共 {{ voucher.length }} 張 收款單 金額總計：{{allMemberTotalPayment()}}</h3>
                    <br />
                    <el-button @click="back" type="primary" plain>返回</el-button>
                </div>
            </div>
        </div>
    </div>
</template>
<script>
import { API } from "@/assets/config";

export default {
    name: "cabinet_printReport",
    data() {
        return {
            id: this.$route.params.id,
            iframeshow: false,
            total: 0,
            // Num 本身就是傳票陣列，不可再包一層，否則取 details 會取到陣列上
            voucher: this.$route.params.Num || [],
            getidList: [],
            works: [
                {
                    account: "",
                    id: "",
                    name: "",
                    // 社員本身 需必填
                    need: true,
                    date: "",
                    content: [],
                    remark: ""
                }
            ],
            value: ""
        };
    },
    created() {
        this.getV();
        this.post();
    },
    methods: {
        getV() {
            const vm = this;
            const removeEl = document.querySelector(".show-container iframe");
            let memberShowID = [];
            if (removeEl !== null) {
                removeEl.remove();
            }
            vm.voucher.forEach(function(val, idx) {
                memberShowID.push(val.main.id);
            });
            return (vm.getidList = memberShowID);
        },
        post() {
            const vm = this;
            let url = API.counterWork + `?action=printCashReceipt`;
            const form = new FormData();
            form.append("idList", JSON.stringify(vm.getidList));
            const loading = this.$loading({
                lock: true,
                text: "Loading",
                spinner: "el-icon-loading",
                background: "rgba(0, 0, 0, 0.7)"
            });

            this.$http
                .post(url, form, { responseType: "blob" })
                .then(response => {
                    let blob = new Blob([response.data], {
                        type: "application/pdf"
                    });
                    let iframe = document.createElement("iframe");
                    iframe.setAttribute("height", "100%");
                    iframe.setAttribute("width", "100%");
                    iframe.setAttribute("id", "ifm");
                    let link = document.createElement("a");
                    let showDom = document.getElementsByClassName("show")[0];
                    iframe.src = window.URL.createObjectURL(blob);
                    showDom.appendChild(iframe);
                    vm.iframeshow = true;
                    loading.close();
                })
                .catch(error => {
                    const reader = new FileReader();
                    reader.addEventListener("loadend", e => {
                        const result = JSON.parse(e.srcElement.result);
                        loading.close();
                        this.$message.closeAll();
                        this.$message({
                            type: "error",
                            message: result.ErrorMessage,
                            duration: 5000
                        });
                    });
                    reader.readAsText(error.response.data);
                });
        },
        allMemberTotalPayment() {
            let total = 0;
            this.voucher.forEach(function(val) {
                // 借方分錄的 creditAmount 可能為空，非數字一律以 0 計
                (val.details || []).forEach(item => {
                    total += parseInt(item.creditAmount, 10) || 0;
                });
            });
            return total;
        },
        show() {},
        go(name) {
            this.$router.push({ name: name });
        },
        back() {
            this.$router.go(-1);
        }
    }
};
</script>
<style lang="scss" scoped>
.fs15 {
    font-size: 15px;
}

.block-content {
    .box-card {
        margin-bottom: 10px;

        &:last-child {
            margin-bottom: 0;
        }

        .table {
            td {
                vertical-align: middle;
            }
        }
    }
}

.fons-set {
    font-size: 18px;
}

.border-set {
    padding: 0px 100px;
    height: 1px;
    border-bottom: 1px solid black;
    position: relative;
    top: -4px;
}
</style>